import { Component, Output, EventEmitter, Input } from '@angular/core';
import { AppEventService, RestDataService} from 'pumpcalc-core';
import { Errors } from '../validation.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-backing-pump-form',
  templateUrl: './backing-pump-form.component.html',
  styleUrls: ['./backing-pump-form.component.css']
})
export class BackingPumpFormComponent {

  @Input() backingPump: { id: string, name: string, parallel: number, gas:string }
  @Output() backingPumpChange: EventEmitter<{ id: string, name: string, parallel: number }> = new EventEmitter();
  @Input() errors ={};
  error=Errors;

  constructor(private appEventService: AppEventService,private restDataService:RestDataService) {
    this.appEventService.events.subscribe(event => {
      if (event.name == "SELECTION" && event.context == "Backing Pump") {
        this.backingPump.id = event.data.id;
        this.backingPump.name = event.data.name;
        this.setBackingPumpSelection(this.backingPump.id);        
      }
    })
  }

  announceChange() {
    this.backingPumpChange.emit(this.backingPump);
  }

  changeBackingPump() {
    this.appEventService.emit({ name: "OPEN_LIST", context: "Backing Pump" });
  }

  setBackingPumpSelection(backingPumpId:string){
    this.restDataService.get(this.restDataService.addIdToURL(backingPumpId,environment.backingPumpDetailsURL)).subscribe((backingPump:any)=>{
      this.backingPump.id = backingPump.id;
      this.backingPump.name = backingPump.name;
      this.backingPump.gas=backingPump.pumpingSpeedCurve.gas;            
      this.announceChange();
    })
  }
  
}
